import { gql } from '@apollo/client';

export default gql`
  mutation deleteArchive($_id: String) {
    deleteArchive(_id: $_id) {
      ok
      error
    }
  }
`;
